export default "__VITE_ASSET__DsdG0wXC__"